module.exports = __webpack_public_path__ + "img/virtualis_slider_overlay.1da9f205.png";